import moment, { Moment } from "moment";

export function getMinutesFromMoment(dateTime: Moment) {
	return moment
		.duration(dateTime.diff(dateTime.clone().startOf("day")))
		.asMinutes();
}
